import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../shared/Button';
import { submitText } from '../../shared/SharedInternationalizations';
import { HelpWithIcon } from '../../shared/HelpIcon';
import { required } from '../../../utilities/general';

export const ChildTableField = () => {
  const helpInfo = {
    helpId: 'FkRepairForm.ChildTableHelpText',
    text: 'The database table name for repairing',
  };
  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className="text-medium text-bold form-item__field-message--required"
          htmlFor="childTable">
          <FormattedMessage
            id="FkRepairForm.ChildTableInputLabel"
            defaultMessage="Child Table:"
            description="Enter child table"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name="childTable"
        component="input"
        validate={required}
      />
    </div>
  );
};

export const ChildFieldName = () => {
  const helpInfo = {
    helpId: 'FkRepairForm.ChildFieldHelpText',
    text: 'The field name in the child table for repairing',
  };
  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className="text-medium text-bold form-item__field-message--required"
          htmlFor="childFieldName">
          <FormattedMessage
            id="FkRepairForm.ChildFieldInputLabel"
            defaultMessage="Child Field:"
            description="Enter child field name"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name="childFieldName"
        component="input"
        validate={required}
        data-test="fkr-childFieldName-input"
      />
    </div>
  );
};

export const ParentTableField = () => {
  const helpInfo = {
    helpId: 'FkRepairForm.ChildTableHelpText',
    text: 'The table name being referenced by child field',
  };

  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className="text-medium text-bold form-item__field-message--required"
          htmlFor="parentTable">
          <FormattedMessage
            id="FkRepairForm.ParentTableInputLabel"
            defaultMessage="Parent Table:"
            description="Enter parent table"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name="parentTable"
        component="input"
        validate={required}
        data-test="fkr-parentTable-input"
      />
    </div>
  );
};

export const RepairActionField = () => {
  const helpInfo = {
    helpId: 'FkRepairForm.RepairActionHelpText',
    text: 'The action to apply to repair records',
  };

  return (
    <div className="form__item-container">
      <div className="align-center">
        <label className="text-medium text-bold form-item__field-message" htmlFor="repairAction">
          <FormattedMessage
            id="fkRepairForm.actionLabel"
            defaultMessage="Repair Action:"
            description="Operation to apply for fixing foreign key"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
        </div>

        <Field
          className="form-item__field"
          name="repairAction"
          component="select"
        >
          {/* NullAction */}
          <FormattedMessage
            id="fkRepairForm.selectNullText"
            defaultMessage="<b>Null</b>"
            key="nullAction"
            values={{
              b: (msg) => <option value="Null-It">{msg}</option>,
            }}
          />

          {/* DeleteAction */}
          <FormattedMessage
            id="fkRepairForm.selectDeleteText"
            defaultMessage="<b>Delete</b>"
            key="DeleteAction"
            values={{
              b: (msg) => <option value="Delete-It">{msg}</option>,
            }}
          />
        </Field>

    </div>
  );
}

export const DryrunField = () => {
  return (
    <div className="content-display__column">
      <div className="align-center">
        <Field
          id="dryrun"
          className="visually-hidden"
          name="dryrun"
          component="input"
          type="checkbox"
          data-test="fkr-dryrun-input"
          disabled={false}
        />
        <label
          htmlFor="dryrun"
          className="text-medium text-light text-deep-blue form-item__field-toggle">
          <FormattedMessage
            id="FkRepairForm.DryRunInputLabel"
            defaultMessage="Commit changes to database"
            description=""
          />
        </label>
      </div>
    </div>
  );
}

const FkRepairForm = (props) => {
  const { onSubmit } = props;

  {/* MAIN */}
  return (
    <React.Fragment>
      <Form
        data-test="foreign-key-repair-form"
        onSubmit={onSubmit}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">
            {/* -- Child Fields */}
            <div className="form__section-container form__section-container--grid margin-bottom-25">
              <ChildTableField />
              <ChildFieldName />
            </div>

            {/*-- PARENT Table */}
            <div className="form__section-container form__section-container--grid margin-bottom-25">
              <ParentTableField />
              <RepairActionField />
            </div>

            {/* DryrunField */}
            <div className="form__section-container form__section-container--grid">
              <div className="content-display__column">
                <DryrunField />
              </div>
            </div>

            <div className="form__section-container form__section-container--spread">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
};

export default FkRepairForm;
